module.exports = __webpack_public_path__ + "static/media/Group279.bd0cca12.png";